import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { observer } from "mobx-react";
import { translate, t } from "../../I18n";
import TextField from "../../components/TextField";
import PhoneField from "../../components/PhoneField";
import FormErrors from "../../components/FormErrors";
import Alert from "../../components/Alert";
const hideFinalAfterMs = 10000;
function CartFirstOrderDiscount(props) {
    const { state, controller } = props;
    const { isFinal } = state;
    const [containerClass, setContainerClass] = useState("");
    const [isHidden, setIsHidden] = useState(false);
    // Applies the final animation and hides message from the UI
    useEffect(() => {
        if (isFinal) {
            setTimeout(() => {
                setContainerClass("animated fadeOut");
            }, hideFinalAfterMs - 1000);
            setTimeout(() => {
                setIsHidden(true);
            }, hideFinalAfterMs);
        }
    }, [isFinal]);
    // TODO: animations between states?
    if (isHidden) {
        return null;
    }
    return (h("div", { class: `cart-multi-column mobile u-mb5 ${containerClass}` },
        h("div", { class: "column info" },
            h("span", { class: "item-title" }, translate(t.first_order_discount.wizard.header)),
            h("div", { class: "animated fadeIn" },
                state.type === "Init" && h(InitState, { onBegin: state.begin }),
                state.type === "Form" && (h(FormState, { controller: controller, onSubmit: state.submit, isLoading: state.isLoading, error: state.error })),
                state.type === "Success" && h(SuccessState, null),
                state.type === "Failure" && h(FailureState, null)))));
}
function InitState(props) {
    const { onBegin } = props;
    return (
    // TODO: e2e tests & remove this data-testid prop
    h("button", { type: "button", onClick: onBegin, class: "btn-link u-text-transform-none u-p0", "data-field-id": "FOD.begin" }, translate(t.first_order_discount.wizard.claim_button)));
}
const FormState = observer((props) => {
    const { controller, onSubmit, isLoading, error } = props;
    const { email, phone } = controller.fields;
    const isMobile = !window.Skubacz.Device.screen.isSmallUp();
    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit();
    };
    return (h("form", { class: "m-form u-mb5", onSubmit: handleSubmit },
        h("p", { class: "u-mb4" }, translate(t.first_order_discount.wizard.description)),
        h(TextField, { name: "email", type: "email", autocomplete: "email", controller: email, required: true, autofocus: true, label: translate(t.activerecord.attributes.user.email), dataFieldId: "FOD.email" }),
        h(PhoneField, { name: "phone", autocomplete: "tel", controller: phone, required: true, label: translate(t.activerecord.attributes.user.phone), dataFieldId: "FOD.phone" }),
        !!error && h(FormErrors, { fieldId: "FOD.errors", errors: [error] }),
        h("button", { type: "submit", onClick: () => controller.submit(), class: `btn btn-default ${isMobile ? "btn-block" : ""}`, "data-field-id": "FOD.submit", disabled: isLoading }, translate(t.first_order_discount.wizard.send_button))));
});
function SuccessState() {
    return (h(Alert, { type: "success", message: translate(t.first_order_discount.wizard.coupon_sent) }));
}
function FailureState() {
    return (h(Alert, { type: "warning", message: translate(t.first_order_discount.wizard.coupon_denied) }));
}
export default observer(CartFirstOrderDiscount);
